export const CardType = Object.freeze({
	Compact: 'task_mini',
	Full: 'task',
});
